module.exports = __webpack_public_path__ + "static/media/fintechnetwork.2c403832.png";